import { render, staticRenderFns } from "./ParamOcorrenciaOrigemFilterBar.vue?vue&type=template&id=7957997a"
import script from "./ParamOcorrenciaOrigemFilterBar.vue?vue&type=script&lang=js"
export * from "./ParamOcorrenciaOrigemFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports